import { useState } from "react";
import type { TournamentEvent } from "../../../../engine/types";
import type { Tournament } from "../../lib/useTournament";

/**
 * One thing sent from a card, and what became of it: still on its way, landed, or refused with
 * the engine's own reason (written to be read by a player).
 */
export function useSent(t: Tournament) {
  const [id, setId] = useState<string | null>(null);
  const refused = id !== null && t.refusal?.id === id ? t.refusal.reason : null;
  const landed = id !== null && t.lastAck?.id === id;
  return {
    send: (event: TournamentEvent): void => setId(t.send(event)),
    refused,
    landed,
    waiting: id !== null && !refused && !landed,
    clear: (): void => setId(null),
  };
}

/** How many characters a typed line has, counted the way the engine counts them. */
export function lengthOf(text: string): number {
  return [...text.trim()].length;
}
